import colors from './colors';
var lightModeColors = {
    textPrimary: colors.pepper100,
    textSecondary: colors.pepper64,
    textTertiary: colors.pepper40,
    surfaceMain: colors.salt100,
    borderPrimary: colors.pepper12,
    a11yFocusIndicator: colors.nightSky100,
};
var darkModeColors = {
    textPrimary: colors.salt100,
    textSecondary: colors.salt72,
    textTertiary: colors.salt48,
    surfaceMain: '#141414',
    borderPrimary: colors.salt16,
    a11yFocusIndicator: colors.banana100,
};
var semanticColors = {
    light: lightModeColors,
    dark: darkModeColors,
};
Object.freeze(semanticColors);
export default semanticColors;
//# sourceMappingURL=semanticColors.js.map